import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Cuộn về đầu trang mỗi khi ĐỔI route (đổi pathname). Trước đây chuyển menu (vd Bảng tin → Video)
 * giữ nguyên vị trí cuộn cũ → trang mới mở ra ở giữa/dưới. Reset window + <main> để luôn về đầu.
 * Bỏ qua khi chỉ đổi query/hash (vd đổi tab ?tab=...) để không phá vị trí đang xem trong cùng trang.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    document.querySelector('main')?.scrollTo?.(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
